import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { pick, isEmpty } from "lodash";
import { apiPost, apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { toast } from "react-toastify";
import AddWebsite from "./AddWebsite";
import Pagination from "../../components/Pagination";

export default function SportSetting() {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const [show, setShow] = useState(false);
  const [matchData, setMatchData] = useState({});
  const [searchParams, setSearchParams] = useState({
    page: 1,
   limit: 10,
  });

  const getMatchData = async () => {
    const { status, data } = await apiGet(apiPath.listWebsite, searchParams);
    if (status === 200 && data.success) {
      setMatchData(data.results);
    }
  };

  const DeletWebsite = async (id) => {
    const { status, data } = await apiPost(apiPath.DeleteWebsite, {
      websiteId: id,
    });
    if (status === 200 && data.success) {
      getMatchData();
      toast.success('Website Deleted Successfully');
    } else {
      toast.error(data?.message);
    }
  };

  useEffect(() => {
    getMatchData();
  }, [searchParams?.page]);
  const handlePageChange = (newPage) => {
    setSearchParams((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <div className="main_wrap">
      <div className="full-wrap">
        <h2>Website Setting</h2>
        <div
          style={{ width: "100%", justifyContent: "end" }}
          className="btn_box"
        >
          <button
            onClick={() => setShow(true)}
            style={{ marginTop: "0" }}
            type="submit"
            className="btn-send size-btn"
          >
            Add Website
          </button>
        </div>

        <table
          id="table_log"
          style={{ marginTop: "13px" }}
          className="table01 funwrap"
        >
          <thead _ngcontent-serverapp-c119>
            <tr _ngcontent-serverapp-c84>
              <th
                _ngcontent-serverapp-c84
                width="5%"
                data-order="asc"
                data-name="playerId"
                className="align-L sort_asc ng-star-inserted"
              >
                Website Name
              </th>
              <th
                _ngcontent-serverapp-c84
                width="5%"
                data-order="asc"
                data-name="playerId"
                className="align-L sort_asc ng-star-inserted"
              >
                Is Used
              </th>

              <th
                _ngcontent-serverapp-c84
                width="5%"
                data-order="asc"
                data-name="playerId"
                className="align-L sort_asc ng-star-inserted"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {matchData?.data?.map((item, index) => (
              <tr key={item?._id || index}>
                <td className="align-L">{item?.domain}</td>
                <td className="align-L">{item?.name}</td>

                <td className="align-L">
                  {" "}
                  <button
                    _ngcontent-serverapp-c94
                    className="btn"
                    onClick={() => DeletWebsite(item?._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {isEmpty(matchData?.data) && (
              <tr>
                <td colSpan={3}>No records found</td>
              </tr>
            )}
          </tbody>
        </table>
        {matchData?.data?.length > 0 && matchData?.totalDocs > 0 && (
          <Pagination pagination={matchData} onPageChange={handlePageChange} />
        )}
      </div>
      {show && (
        <AddWebsite
          isOpen={show}
          closeModal={() => setShow(false)}
          getData={getMatchData}
        />
      )}
    </div>
  );
}
